/**
 * mediaUtils.js
 * ─────────────
 * Helpers for video/audio posts (postFormat, mediaUrl, mediaDurationSeconds).
 * Shared by the Post List playlist/episodes layouts and the Video Embed block.
 */

/** YouTube / Vimeo page URLs → embeddable player URL; other https URLs pass through. */
export function toEmbedUrl(url) {
	var u = String(url || '');
	if (!u) return '';
	var yt = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/);
	if (yt) return 'https://www.youtube.com/embed/' + yt[1];
	var vm = u.match(/vimeo\.com\/(?:video\/)?(\d{1,12})/);
	if (vm) return 'https://player.vimeo.com/video/' + vm[1];
	return /^https:\/\//i.test(u) ? u : '';
}

/** True when the URL points at a file the <audio> element can play directly. */
export function isAudioFile(url) {
	return /\.(mp3|m4a|aac|ogg|oga|wav|flac)(\?.*)?$/i.test(String(url || ''));
}

/** 754 → "12:34"; 3725 → "1:02:05"; falsy → ''. */
export function formatDuration(seconds) {
	var s = parseInt(seconds, 10);
	if (!s || s < 0) return '';
	var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
	var mm = h ? String(m).padStart(2, '0') : String(m);
	return (h ? h + ':' : '') + mm + ':' + String(sec).padStart(2, '0');
}

/** 'video' | 'audio' | '' for a post item. */
export function postFormat(item) {
	var f = item && item.postFormat;
	return f === 'video' || f === 'audio' ? f : '';
}
